import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import Goal from '../images/goal.svg'
import Games from '../images/games.svg'
import Assist from '../images/assist.svg'
import Dribble from '../images/dribble.svg'
import Tackle from '../images/tackle.svg'
import YellowCard from '../images/yellowcard.svg'
import RedCard from '../images/redcard.svg'
import Penalty from '../images/penalty.svg'

console.log(Goal)

function PlayersCard() {
  let params = useParams()
  const [playerData, setPlayerData] = useState([])

  useEffect(() => {
    console.log(params.id)
    fetchPlayer(params.id)
  }, [])

  const fetchPlayer = (id) => {
    const options = {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': '42b487df01msh9367a40af1580cap17dd76jsn8040671db253',
        'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com',
      },
    }

    fetch(
      `https://api-football-v1.p.rapidapi.com/v3/players?id=${id}&league=2&season=2022`,
      options
    )
      .then((response) => response.json())
      .then((response) => {
        console.log(response.response)
        setPlayerData(response.response)
      })
      .catch((err) => console.error(err))
  }

  return (
    <div className=''>
      {playerData.map((item) => {
        return (
          <>
            <section className=' '>
              <div className='grid grid-cols-1 md:grid-cols-2  mx-auto pt-32  w-5/6 my-auto  font-arvo font-medium  '>
                <div className=' text-white   min-h-[350px] '>
                  <div className=' h-1/2 '>
                    <div className=' h-full flex'>
                      <div className='w-2/5 flex items-center justify-end'>
                        <img
                          className=' h-[100px]'
                          src={item.statistics[0].team.logo}
                        />
                      </div>

                      <div className='w-3/5 flex flex-col justify-center items-start ml-2'>
                        <h1 className=' text-black'>
                          {item.statistics[0].games.position}
                        </h1>
                        <h1 className=' text-black  text-3xl'>
                          {item.statistics[0].team.name}
                        </h1>
                      </div>
                    </div>
                  </div>

                  <div className=' h-1/2'>
                    <div className='w-5/6 h-5/6  mx-auto my-auto mt-2'>
                      <div className=' h-1/3 border-t-2 border-t-gray-300 '>
                        <div className='flex  h-full'>
                          <div className='w-1/3 h-full text-gray-400 flex items-center ml-1 text-sm '>
                            Nationalty
                          </div>
                          <div className='w-2/3 h-full text-black flex justify-end items-center mr-1'>
                            {item.player.nationality}
                          </div>
                        </div>
                      </div>

                      <div className=' h-1/3 border-t-2 border-t-gray-300 '>
                        <div className='flex  h-full'>
                          <div className='w-1/3 h-full text-gray-400 flex items-center ml-1 text-sm'>
                            Height
                          </div>
                          <div className='w-2/3 h-full text-black flex justify-end items-center mr-1'>
                            {item.player.height}
                          </div>
                        </div>
                      </div>

                      <div className=' h-1/3 border-t-2 border-t-gray-300 '>
                        <div className='flex  h-full'>
                          <div className='w-1/3 h-full text-gray-400 flex items-center ml-1 text-sm '>
                            Age
                          </div>
                          <div className='w-2/3 h-full text-black flex justify-end items-center mr-1'>
                            {item.player.age}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=' py-10 border-b-2 border-black md:border-l-2 md:border-b-white  border-black  -order-1 md:order-last'>
                  <div className=' flex justify-center  '>
                    <img src={item.player.photo} />
                  </div>
                  <div className='border-y-2  border-gray-300 flex mt-6 justify-center w-5/6 mx-auto py-2'>
                    <h3 className='text-lg'>{item.player.firstname}</h3>
                    <h1 className=' ml-2 text-lg'>{item.player.lastname}</h1>
                  </div>
                </div>
              </div>
            </section>

            <section className=' mt-12 h-[300px] w-5/6 mx-auto  '>
              <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 pb-12'>
                <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                  <div className='h-2/5 mt-10 rounded-full border-t-2  border-b-2 border-b-gray-200  border-t-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                    <div className=' text-4xl'>
                      {item.statistics[0].games.appearences}
                    </div>
                  </div>
                  <div className='  h-2/5 '>
                    <div className='  flex justify-center '>
                      <img className=' w-12 h-12' src={Games} />
                    </div>
                    <div className=' flex justify-center mt-2'>
                      <h1 className='text-xl md:text-4xl'>Games</h1>
                    </div>
                  </div>
                </div>

                <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                  <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200  border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                    <div className=' text-4xl'>
                      {item.statistics[0].goals.total}
                    </div>
                  </div>
                  <div className='  h-2/5 '>
                    <div className='  flex justify-center '>
                      <img className=' w-12 h-12' src={Goal} />
                    </div>
                    <div className=' flex justify-center mt-2'>
                      <h1 className='text-xl md:text-4xl'>Goals</h1>
                    </div>
                  </div>
                </div>

                <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                  <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                    <div className=' text-4xl'>
                      {item.statistics[0].goals.assists}
                    </div>
                  </div>
                  <div className='  h-2/5 '>
                    <div className='  flex justify-center '>
                      <img className=' w-12 h-12' src={Assist} />
                    </div>
                    <div className=' flex justify-center mt-2'>
                      <h1 className='text-xl md:text-4xl'>Assists</h1>
                    </div>
                  </div>
                </div>

                <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                  <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                    <div className=' text-4xl'>
                      {item.statistics[0].penalty.scored}
                    </div>
                  </div>
                  <div className='  h-2/5 '>
                    <div className='  flex justify-center '>
                      <img className=' w-12 h-12' src={Penalty} />
                    </div>
                    <div className=' flex justify-center mt-2'>
                      <h1 className='text-xl md:text-4xl'>Penaltys</h1>
                    </div>
                  </div>
                </div>

                <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                  <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                    <div className=' text-4xl'>
                      {item.statistics[0].dribbles.success}
                    </div>
                  </div>
                  <div className='  h-2/5 '>
                    <div className='  flex justify-center '>
                      <img className=' w-12 h-12' src={Dribble} />
                    </div>
                    <div className=' flex justify-center mt-2'>
                      <h1 className='text-xl md:text-4xl'>Dribbles</h1>
                    </div>
                  </div>
                </div>

                <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                  <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                    <div className=' text-4xl'>
                      {item.statistics[0].tackles.total}
                    </div>
                  </div>
                  <div className='  h-2/5 '>
                    <div className='  flex justify-center '>
                      <img className=' w-12 h-12' src={Tackle} />
                    </div>
                    <div className=' flex justify-center mt-2'>
                      <h1 className='text-xl md:text-4xl'>Tackles</h1>
                    </div>
                  </div>
                </div>

                <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                  <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200  border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                    <div className=' text-4xl'>
                      {item.statistics[0].cards.red}
                    </div>
                  </div>
                  <div className='  h-2/5 '>
                    <div className='  flex justify-center '>
                      <img className=' w-12 h-12' src={RedCard} />
                    </div>
                    <div className=' flex justify-center mt-2'>
                      <h1 className='text-xl md:text-4xl'>Red Cards</h1>
                    </div>
                  </div>
                </div>

                <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                  <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                    <div className=' text-4xl'>
                      {item.statistics[0].cards.yellow}
                    </div>
                  </div>
                  <div className='  h-2/5 '>
                    <div className='  flex justify-center '>
                      <img className=' w-12 h-12' src={YellowCard} />
                    </div>
                    <div className=' flex justify-center mt-2'>
                      <h1 className='text-xl md:text-4xl'>Yellow Cards</h1>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )
      })}
    </div>
  )
}

export default PlayersCard
